
<template>
	<div class="panel panel-default">
  		<ly-fixheader :title="title" btn="save"></ly-fixheader>	
		<div class="panel-body">
			<form class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-2 control-label">名称 *</label>
					<div class="col-sm-10">
				  	<ly-input :value.sync="data.name" title="管理公司名称"></ly-input>
				</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">编号</label>
					<div class="col-sm-10">
					  <ly-input :value.sync="data.code" title="管理公司编号" must="false" v-if="!isUpdate"></ly-input>
					  <label class="control-label" v-else>{{data.code}}</label>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">预分类</label>
					<div class="col-sm-10">
						<div class="col-md-8 pl0">
							<select v-model="data.classify" class="form-control">
					    		<option value="A">A类管理公司(普通单店)</option>
					    		<option value="B">B类管理公司(实力型个体)</option>
					    		<option value="C">C类管理公司(公司型KA)</option>
					    	</select>
						</div>			    	
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">区域</label>
					<div class="col-sm-10">
						<div class="col-md-8 pl0">
					    	<ly-address :address="data.area" v-ref:area></ly-address>
						</div>	
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">详细地址 *</label>
					<div class="col-sm-10">
					  <ly-input :value.sync="data.address" title="详细地址" max="100"></ly-input>	
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">管理公司负责人 *</label>
					<div class="col-sm-10">
					  <ly-input :value.sync="data.companyer" title="管理公司负责人"></ly-input>	
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">管理公司电话 *</label>
					<div class="col-sm-10">
					  <ly-input :value.sync="data.company_phone" title="管理公司电话" type="tel"></ly-input>	
					</div>
				</div>
				<div class="form-hr"></div>
				<div class="form-group">
					<label class="col-sm-2 control-label">最大建店数 *</label>
					<div class="col-sm-10">
					  <ly-input :value.sync="data.create_shop_max" title="最大建店数" type="posnumber"></ly-input>	
					</div>
				</div>
				<div class="form-hr"></div>
					<div class="form-group">
					<label class="col-sm-2 control-label">工商执照号</label>
					<div class="col-sm-10">
					  <ly-input :value.sync="data.business_license_no" title="工商执照号" must="false" type="license"></ly-input>	
					</div>
				</div>
				<div class="form-group">
				<label class="col-sm-2 control-label">执照照片</label>
					<div class="col-sm-10">
						<div class="col-md-8 pl0">
							<ly-imgupload :image="data.license_img" v-ref:license></ly-imgupload>
						</div>
					</div>
				</div>
				<div class="form-hr"></div>
				<div class="form-group">
					<label class="col-sm-2 control-label">公司管理员姓名 *</label>
					<div class="col-sm-10">
					  <ly-input :value.sync="data.manage_admin" title="公司管理员姓名"></ly-input>	
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">管理员账户 *</label>
					<div class="col-sm-10">
					  <ly-input :value.sync="data.manage_phone" title="管理员账户(手机号码)" type="phone" v-if="!isUpdate" maxlength="11"></ly-input>	
					  <label class="control-label" v-else>{{data.manage_phone}}</label>
					</div>
				</div>
				<div class="form-group" v-if="!isUpdate">
					<label class="col-sm-2 control-label">该账户初始密码 *</label>
					<div class="col-sm-10">
					  <ly-input :value.sync="data.manage_admin_password" title="管理员账户初始密码" type="password"></ly-input>	
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">负责BD *</label>
					<div class="col-sm-10">
					  <ly-input :value.sync="data.BD" title="请输入真名全名"></ly-input>	
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label">有效期 *</label>
					<div class="col-sm-6">
					 	<div class="col-sm-4" style="padding:0;">
					 		<input type="number" class="form-control" v-model="time">
					 	</div>
					 	<div class="col-sm-2 pr0">
					 		<select class="form-control" v-model="type">
					 			<option value="A">月</option>
					 			<option value="B">日</option>
					 		</select>
					 	</div>
					 	<div class="col-sm-4" style="padding-top:7px;">到期时间: {{expiration_time_new}} </div>
					</div>
				</div>
				<div class="form-group ptb10">
				    <label class="col-sm-2 control-label">是否可使用手机端</label>
				    <div class="col-md-10">
				    	<label class="radio-inline" v-for="el in phoneLoginArr">
							<input type="radio" :value="el.is_phone" v-model="data.is_phone"> {{el.text}}
						</label>
				    </div>
			  	</div>
			</form>
	    </div>
    </div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var Common = require('../utils/Common.js');
	var data = {		
		name : '',//管理公司名字
		code : '',//管理公司编号
		classify : 'A',//预分类
		area: '',//区域
		address : '',//详细地址
		companyer : '',//管理公司负责人
		company_phone : '',//管理公司电话
		create_shop_max : 1,//最大建店数
		business_license_no : '',//工商执照号
		license_img : '',//执照照片
		manage_admin : '', //管理人员
		manage_phone : '', //管理员电话
		manage_admin_password : '', //该账户初始密码
		BD: '',//负责BD
		expiration_time:'',//到期时间
		is_phone: 1,//是否可登录手机端
	};//上传的数据

	/**
	* 返回的处理
	*/
	var goback = function(vm){
		if(vm.isUpdate){
			vm.$dispatch('closeUpdate');
			vm.isUpdate = false;
		}else{
			Common.go('');
		}
	};
	/**
	* 门店照片的获取
	* @param vm 对应当前的ViewModel
	*/
	var licenseImg = function(vm){
		var one = vm.$refs.license.img;
		if(one.length > 0){
			vm.data.license_img = one;
		}
	};
	/**
	* 区域的获取
	*/
	var getArea = function(vm){
		vm.data.area = vm.$refs.area.fullArea;
	};
	/**
	* 新增
	*/
	var create = function(vm){
		Http['company'].create({
			data : vm.data,
			succ : function(rs){
				data = {		
					name : '',//管理公司名字
					code : '',//管理公司编号
					classify : 'A',//预分类
					area: '',//区域
					address : '',//详细地址
					companyer : '',//管理公司负责人
					company_phone : '',//管理公司电话
					create_shop_max : 1,//最大建店数
					business_license_no : '',//工商执照号
					license_img : '',//执照照片
					manage_admin : '', //管理人员
					manage_phone : '', //管理员电话
					manage_admin_password : '', //该账户初始密码
					BD: '',//负责BD
					expiration_time:'',//到期时间
				};//上传的数据
				Common.tipDialog("数据保存成功",1000,'success');
				goback(vm);
			},
			err  : function(msg){
				Common.tipDialog(msg,1500,'error');
			}
		});			
	};
	/**
	* 修改
	*/
	var save = function(vm){
		//修改时不上传管理员账户和编码
		delete vm.data.manage_phone;
		delete vm.data.code;
		delete vm.data.exprice;
		Http['company'].save({
			key : [vm.data.id],
			data : vm.data,
			succ : function(rs){
				Common.tipDialog("数据保存成功",300,'success');
				//分发事件		
				goback(vm);
				vm.data.manage_phone = vm.manage_phone;//由于manager_phone从data里面移除了，需重新赋值
				vm.data.code = vm.code;//由于code从data里面移除了，需重新赋值
				vm.$dispatch("expiration",vm.data.expiration_time);//向上传递最新到期时间
			},
			err  : function(msg){
				Common.tipDialog(msg,1500,'error');
			}
		});		
	};
	/**
	* ViewModel
	*/
	module.exports = {
		props : ['info'],//修改时传递过来的数据
		data : function () {
			return {
				data : data,
				title: '新增管理公司信息',
				isUpdate: false,//标识是[false:新增,true:修改]
				manage_phone: '',//管理员账户
				code: '',//管理公司编码
				time: 12,//有效期
				type: 'A',//月、日
				expiration_timeold:'',//续费前的过期时间
				phoneLoginArr: [
					{
						is_phone: 1,
						text: "可使用"
					},{
						is_phone: 2,
						text: "不可使用"
					}]
			};
		},
		created : function(){

		},
		components : {
			'ly-imgupload' : require('../components/Imgupload.vue'),
			'ly-address' : require('../components/Address.vue'),
			'ly-fixheader' : require('../components/Fixheader.vue'),
			'ly-input': require('../components/input/text.vue')
		},
		ready:function(){
			if(this.info != undefined){//判断是否有数据，没有表示为新增，有表示为修改
				this.isUpdate = true;
				this.title = '修改管理公司信息';
				this.$set('data',this.info);
				this.manage_phone = this.info.manage_phone;
				this.code = this.info.code;
				this.time = 12;
				this.type = "A";
				this.expiration_timeold = this.info.expire;
			}else{//新增的时候获取系统时间
				this.expiration_timeold = Common.getCurTime();
			}
			var self = this;
		},
		computed:{
			"expiration_time_new":function(){
				var nd = new Date(this.expiration_timeold);
				if(this.type =="A"){
					if(this.time > 60|| this.time < 0){
						this.time = 12;
						nd.setMonth(nd.getMonth()+parseInt(this.time));
					}else{
						if(!this.time){
							this.time = 0;
						}
						nd.setMonth(nd.getMonth()+parseInt(this.time));
					}
				}
				if(this.type =="B"){
					if(this.time > 1830 || this.time < 0){
						this.time = 365;
						nd.setDate(nd.getDate()+parseInt(this.time));
					}else{
						if(!this.time){
							this.time = 0;
						}
						nd.setDate(nd.getDate()+parseInt(this.time));
					}	
				}
				var y = nd.getFullYear();  
				var m = nd.getMonth()+1;  
				var d = nd.getDate();  
				if(m <= 9) m = "0"+m;  
				if(d <= 9) d = "0"+d;   
				this.data.expiration_time = y+"-"+m+"-"+d;
				return this.data.expiration_time;
			}
		},
		methods: {
			goback : function(){
				goback(this);//这个是上面声明的函数
			}
		},
		events : {
			submit : function(){
				licenseImg(this);//获取照片
				getArea(this);//获得选择的区域
				if(Common.isAdopt(this)){		
					Common.tipDialog('保存中,请稍后...',0,'loading');			
					var self = this;
					if(self.isUpdate){
						save(self);
					}else{
						create(self);
					}
				}
			},
			goback : function(){
				goback(this);//这个是上面声明的函数
				this.data.expiration_time = '';
			}
		}
	}
</script>


/** WEBPACK FOOTER **
 ** company_add.vue?f758b140
 **/